import React, { Component } from 'react'
import * as actions from "../actions";
import * as utils from "../../utils";

import PollHeader from "./poll-header";

const PollResults = React.createClass({
  render: function() {
    const poll = this.props.poll;
    const { question, created, options, id, total_response_count } = poll;
    let option_nodes = []
    if (options.length > 0) {
      const most_votes = options.reduce((prev, current) => {
          return (prev.response_count > current.response_count) ? prev : current
        }
      );
      option_nodes = options.map((option, i) => {
        const response_count = option.response_count;
        const percent = total_response_count > 0 ? (response_count / total_response_count) * 100 : 0;
        const barStyle = {width: `${percent}%`};
        const winner = most_votes.response_count === response_count ? "winner" : "";
        return (
          <li key={`poll-results-${ i }`}>
            { option.option }
            <div className="vote-bar-wrap">
              <div className="vote-count">{response_count}</div>
              <div className="vote-bar">
                <div className={ "inner " + winner } style={ barStyle }></div>
              </div>
            </div>
          </li>
        )
      });
    }
    return (
      <div className="polls poll-results simple-shadowbox">
        <div className="polls-inner">
          <PollHeader poll={ poll } />
          <ul className="poll-bars">
            { option_nodes }
          </ul>
        </div>
        <div className="btn-container">
          <a href="#" onClick={ this.changeVote }>
            { poll.voted ? "Change your vote" : "Add your vote" }
          </a>
        </div>
      </div>
    )
  },
  changeVote: function(e) {
    e.preventDefault();
    actions.setVoted(this.props.poll.id, false, utils.isHost());
  }
});

export default PollResults;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/polls/components/poll-results.es6